// extracted by mini-css-extract-plugin
export default {"root":"style_root__wPTuF","flatLink":"style_flatLink__k2-l+","arrowLeft":"style_arrowLeft__mZT8L","title":"style_title__oWV3K"};